// src/utils/axiosConfig.js

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_backend,
  withCredentials: true, // Enviar cookies con cada solicitud
});

export default axiosInstance;
